<i18n src="../../locales/lang.json"></i18n>
<template>
  <div class="container-fluid" ref="container">
    <div class="row">
      <div class="col-lg-12 px-0 mt-3">
        <html-templates @selected_template="selectTemplate" class="px-0"></html-templates>
      </div>
      <div class="col-lg-12 px-0 mt-3">
        <new-mce-editor filefolder="News" ref="mce" v-model="description"></new-mce-editor>
      </div>
      <div class="col-12 px-0 mt-3 custom-form-label">
        {{$t('publishdate')}}
      </div>
      <div class="col-12 px-0 mt-1">
        <input-inline-date ref="publishDateControl" drops="up" @changed="changePublishDate"></input-inline-date>
      </div>
      <div class="col-12 px-0 custom-form-label mt-3">
        <input-checkbox @input="enableTeamSelector" ref="checkboxOnAddRef" value="1" id="chk_teamEmailOnAdd"
                        name="chk_teamEmailOnAdd" v-bind:checked="false"
                        v-bind:text="$t('send_mail_notification')"></input-checkbox>
      </div>
      <div v-show="displayTeamSelector == true" class="col-sm-12 px-0 mt-3">
        <team-select-selector @event-change-team="changeTeam" ref="teamSelectorOnAddRef"></team-select-selector>
      </div>
      <div class="col-lg-12 form-group pt-3 px-0">
        <a style="color:inherit" v-show="mode == 'add'" @click="addNews" class="btn btn-link skin btn-primary pull-right">{{$t('add')}}</a>
        <a style="color:inherit" v-show="mode == 'update'" @click="updateNews" class="btn btn-link skin btn-primary pull-right">{{$t('update')}}</a>
        <a style="color:inherit" @click="cancel" class="btn skin btn-link pull-right mr-1">{{$t('cancel')}}</a>
      </div>

      

    </div>
    <common-ticker ref="ticker"></common-ticker>
  </div>
</template>

<script>

  export default {
    name: "news-editor",
    components: {
      
    },
    props: {
      
    },
    data() {
      return {
        mode: 'add',
        displayTeamSelector: false,
        selectedTeam: 0,
        selectedId: -1,
        sendemailonAdd: false,
        publishDate: null,
        description:"",
      };
    },
    methods: {
      changePublishDate(date) {
        this.publishDate = date.format("YYYY-MM-DD");
      },
      cancel() {
        this.selectedId = -1;
        this.publishDate = null;
        this.mode = 'add';
        //this.$refs.mce.value = "";
        //this.$refs.mce.setValue("");
        this.description = "";
        this.sendemailonAdd = false;
        this.$emit("cancel", "news")
        this.$root.$emit("cancel_news")
      },
      changeTeam(val) {
      },
      enableTeamSelector(value, name) {
        this.sendemailonAdd = value;
        //this.selectedTeam = value;
        this.displayTeamSelector = value;
        this.$forceUpdate();
      },
      reset() {
        this.mode = "add";
        this.selectedId = -1;
        var d = this.$store.getMomentLocale(new Date());
        this.publishDate = d.format("L");
        this.$refs.publishDateControl.setDate(d.format("L"));
        this.mode = 'add';
        this.description = "";
        //this.$refs.mce.value = "";
        //this.$refs.mce.setValue("");
        this.sendemailonAdd = false;
      },
      update(id) {

        this.mode = "update";
        this.selectedId = id;
        this.loadNews(id);
      },
      copy(id) {
        this.mode = "add";
        this.loadNews(id);
      },
      selectTemplate(template) {
        //this.$refs.mce.setValue(template.markup);
        this.description = template.markup;
      },
      loadNews(id) {
        this.notificationid = id;
        try {
          this.$refs.ticker.start(this.$refs.container.getAttribute('id'));
          var url = '/api/Notification/v1/' + id;
          this.$http.get(url).then(async response => {

            //this.$refs.mce.value = response.data.Description;
            //this.$refs.mce.setValue(response.data.Description);
            this.description = response.data.Description;
            this.teamid = response.data.TeamId;

            if (response.data.StartPublish == null) {
              this.$refs.publishDateControl.setDate('');
              this.publishDate = null;
            }
            else {
              
              var d = this.$store.getMomentLocale(response.data.StartPublish);
              this.$refs.publishDateControl.setDate(d.format("L"));
              this.publishDate = d.format("L");
            }

            //this.$forceUpdate();
             
          });
        }
        catch (err) {
          this.$refs.ticker.end(this.$refs.container.getAttribute('id'));
        }
      },

      updateNews() {
        //this.$refs.ticker.start(this.$refs.container.getAttribute('id'));
        var data = {
          NotificationId: this.selectedId,
          TeamId: this.selectedTeam,
          SendemailonAdd: this.sendemailonAdd,
          Description: this.description,
          PublishDate: this.publishDate,
        };
        var postString = JSON.stringify(data);
        var thisContext = this;
        var response = this.$http.put(
          '/api/Notification/v1/' + this.selectedId ,
          postString,
          {
            headers: {
              'Content-Type': 'application/json',
              "Accept": "application/json"
            }
          }
        )
          .then(response => {
            //this.$refs.ticker.end(this.$refs.container.getAttribute('id'));
            this.$root.$emit("updated");
            this.$root.$emit("updated_news");
            
          });
      },

      async addNews() {
        this.$refs.ticker.start(this.$refs.container.getAttribute('id'));
        var data = {
          TeamId: this.selectedTeam,
          Description: this.description,
          SendemailonAdd: this.sendemailonAdd,
          PublishDate: this.publishDate,
        };
        var postString = JSON.stringify(data);
        var response = await this.$http.post(
          '/api/Notification/v1',
          postString,
          {
            headers: {
              'Content-Type': 'application/json',
              "Accept": "application/json"
            }
          }
        )
          .then(response => {
            this.reset();
            //this.mode = "update";
            //this.selectedId = response.data.Id;
            this.$root.$emit("added");
            this.$root.$emit("added_news");
            this.$refs.ticker.end(this.$refs.container.getAttribute('id'));
          });
      },

      getId() {
        return this._uid;
      },

      handleRefresh(val) {
        this.$forceUpdate();
      },
      init() {
        //this.$refs.mce.initMCE();
      }
    },
    computed: {
      
    },
    watch: {
      
    },
    mounted() {
      this.init();

    },
    created() {

    },
  };

</script>

<style scoped>
  

</style>



// WEBPACK FOOTER //
// src/components/startpage/news-editor.vue